import { aclPermissions, hasPermissions } from "const/ACLPermissions"
import { openEndPoint } from "./utils"
import {checkAbstractAppPermission, launchOnCasePage} from "../component/utils/abstract_app_maker";

export const openFolderEndpoint = (newTab) => {
    openEndPoint(getFolderEndpoint(), newTab, true)
}

export const getFolderEndpoint = () => {
    const showFolder = hasPermissions([aclPermissions.folders_menu])
    if (showFolder) return "/patient_folders/"
    return "/cases/"
}

export const openDefaultEndpoint = (newTab) => {
    openEndPoint(getDefaultEndpoint(), newTab, true)
}

export const getDefaultEndpoint = () => {
    const showFolder = hasPermissions([aclPermissions.folders_menu])
    if (showFolder) return "/patient_folders/"

    if (checkAbstractAppPermission(launchOnCasePage)) return "/cases/"

    return "/dashboard/"
}